import React from 'react';
import { BatteryMedium, Signal, Wifi } from 'lucide-react';
import { ASSETS } from '../../lib/assets';
export function PhoneFrame({
  children,
  time = '9:28'
}: {
  children: React.ReactNode;
  time?: string;
}) {
  return <div className="relative mx-auto w-full max-w-[360px]" data-id="element-146" data-mp="21xr7tjjjbcjf">
      <div className="relative overflow-hidden rounded-[2rem] border-[8px] border-black bg-black shadow-2xl" data-id="element-147" data-mp="1x6iy0mealp5q">
        <div className="relative flex h-[690px] flex-col bg-[#c9b6c7] font-rounded" style={{
        backgroundImage: `url(${ASSETS.mobileBg})`,
        backgroundPosition: 'center',
        backgroundSize: 'cover'
      }} data-id="element-148" data-mp="2ax4gwb3qxz3m">
          <StatusBar time={time} data-id="element-149" data-mp="2fwqwusayltg4" />
          <div className="relative flex min-h-0 flex-1 flex-col overflow-hidden" data-id="element-150" data-mp="2fwh2ytmsn255">{children}</div>
          <SystemNav data-id="element-151" data-mp="qh0znuvjwan6" />
        </div>
      </div>
    </div>;
}
function StatusBar({
  time
}: {
  time: string;
}) {
  return <div className="flex h-6 shrink-0 items-center justify-between bg-black px-3 text-[9px] font-semibold text-white" data-id="element-152" data-mp="lkaif480f906">
      <span data-id="element-153" data-mp="jwka2ynaisj">{time}</span>
      <div className="flex items-center gap-1" data-id="element-154" data-mp="5l3u07kcls1u">
        <Signal className="h-3 w-3" data-id="element-155" data-mp="5lvpzjhuxrsn" />
        <Wifi className="h-3 w-3" data-id="element-156" data-mp="5ipwls2743r4" />
        <BatteryMedium className="h-3.5 w-3.5" data-id="element-157" data-mp="9mfk0e74wfak" />
        <span data-id="element-158" data-mp="9kkyaxo1gj5f">58</span>
      </div>
    </div>;
}
function SystemNav() {
  return <div className="flex h-7 shrink-0 items-center justify-around bg-black px-14" data-id="element-159" data-mp="eez1hm8xzukn">
      <span className="h-0 w-0 border-y-[5px] border-r-[8px] border-y-transparent border-r-white/80" data-id="element-160" data-mp="jbpc3u1z9xyo" />
      <span className="h-3 w-3 rounded-full border border-white/80" data-id="element-161" data-mp="oaacpul56jnn" />
      <span className="h-2.5 w-2.5 rounded-[1px] bg-white/80" data-id="element-162" data-mp="ta52fut6l374" />
    </div>;
}